import { http } from "@/api";

const Qs = require("qs");

/**
 * Solicita os KPI de anomalia das unidades geradoras.
 * @param {Array} mtIds Conjunto de ids do elemento de monitração do tipo unidade geradora.
 * @returns Array com os KPIs das unidades geradoras consultadas.
 */
const GetList = function(mtIds)
{
	return http.get("/AnomalyDetectionsKPIs",
		{
			params:           { mtIds: mtIds, },
			paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
		});
};

export default { GetList };